import ChangePassword from "./change-password.container";

export default ChangePassword;
